import AuthRegisterAPI from '@/app/apis/auth/auth-register/auth-register-api.js';

export default {
  /**
   * @param {*} authDetails
   */
   async putAuthRegister(authDetails) {
     return AuthRegisterAPI.putAuthRegister(authDetails);
   }
}